import { render, staticRenderFns } from "./PrintLabels.vue?vue&type=template&id=054e3f10"
import script from "./PrintLabels.vue?vue&type=script&lang=js"
export * from "./PrintLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports